import React from "react";
import { makeStyles } from "@material-ui/core";
import { Helmet } from "react-helmet";
import "./AboutUs.css";

// Components
import About from "./About";
import Testimonial from "./Testimonial";
import OurServices from "./OurServices";
import SetsUsApart from "./SetsUsApart";
import Reviews from "./Reviews";
import OpenGraphMeta from "../../components/SEO/OpenGraphMeta.jsx";

const useStyles = makeStyles((theme) => ({
	aboutUs: {},
}));

const AboutUs = () => {
	const classes = useStyles();
	return (
		<div className={classes.aboutUs}>
			<Helmet>
				<title>About Us | IT Infrastructure Experts | Kinetx Co</title>
				<meta 
					name="description" 
					content="Learn about Kinetx Co — expert IT infrastructure solutions provider serving Miami and NYC businesses. Our team, mission, and commitment to excellence." 
				/>
				<link rel="canonical" href="https://www.kinetx.co/about-us" />
			</Helmet>
			<OpenGraphMeta
				title="About Us | IT Infrastructure Experts | Kinetx Co"
				description="Learn about Kinetx Co — expert IT infrastructure solutions provider serving Miami and NYC businesses. Our team, mission, and commitment to excellence."
				url="https://www.kinetx.co/about-us"
			/>
			<About />
			<Testimonial />
			<OurServices />
			<SetsUsApart />
			<Reviews />
		</div>
	);
};

export default AboutUs;
